import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import isEqual from 'lodash/isEqual';
import { mapFieldValueFromInternalToPublic } from '../map-field-value-from-internal-to-public';
export var calculateNextFormValue = function calculateNextFormValue(_ref) {
  var _formData$fieldId;
  var internalFormMetadata = _ref.internalFormMetadata,
    formData = _ref.formData,
    fieldId = _ref.fieldId,
    fieldValue = _ref.fieldValue,
    fieldType = _ref.fieldType,
    viewType = _ref.viewType;
  if (formData === null) {
    return null;
  }
  var newPublicValue;
  try {
    newPublicValue = mapFieldValueFromInternalToPublic({
      fieldMetadata: internalFormMetadata[fieldId],
      internalFieldValue: fieldValue,
      fieldType: fieldType,
      viewType: viewType
    });
  } catch (e) {
    return null;
  }
  var currentPublicValue = (_formData$fieldId = formData[fieldId]) === null || _formData$fieldId === void 0 ? void 0 : _formData$fieldId.value;
  if (isEqual(newPublicValue, currentPublicValue)) {
    return null;
  }
  return _objectSpread(_objectSpread({}, formData), {}, _defineProperty({}, fieldId, _objectSpread(_objectSpread({}, formData[fieldId]), {}, {
    value: newPublicValue
  })));
};